import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";
import useWindowDimensions from "../utils/dimensions";
import {ArrowUp} from "lucide-react";

const BackToTop = styled(({className, scrollToTop}) => {
    const {width} = useWindowDimensions();
    return (
        <div className={className} onClick={scrollToTop} style={{padding: width > 970 ? '8px 16px' : '12px'}}>
            {width > 970 ? 'Back to Top' :  <ArrowUp size={22} />}
        </div>
    );
})`
  cursor: pointer;
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 2;
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  border-radius: 48px;
  font-size: 14px;
  font-weight: 500;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
`;

export default BackToTop;
